import { Component, HostListener, Inject, OnInit, DOCUMENT } from "@angular/core";
import { PictureService } from "src/app/_services/picture.service";
import { FilePartial as WiFilePartial } from "src/app/api/models";


@Component({
    selector: "custom-lightbox",
    templateUrl: "./lightbox.component.html",
    styleUrls: ["./lightbox.component.scss"],
    standalone: false
})
export class LightboxComponent implements OnInit {
  showModal: boolean = false;
  currentImageIndex: number = undefined;
  picturesInLightbox: WiFilePartial[] = [];

  constructor(
    public pictureService: PictureService,
    @Inject(DOCUMENT) public document: Document
  ) {}

  ngOnInit(): void {}

  @HostListener("window:keydown", ["$event"])
  handleKeyDown(event: KeyboardEvent) {
    if (this.showModal) {
      switch (event.key) {
        case "ArrowLeft":
          this.previousImage();
          break;
        case "ArrowRight":
          this.nextImage();
          break;
        case "Escape":
          this.closeModal();
          break;
      }
    }
  }

  nextImage() {
    if (this.currentImageIndex === this.picturesInLightbox.length - 1) {
      this.currentImageIndex = 0;
    } else {
      this.currentImageIndex = this.currentImageIndex + 1;
    }
  }

  previousImage() {
    if (this.currentImageIndex === 0) {
      this.currentImageIndex = this.picturesInLightbox.length - 1;
    } else {
      this.currentImageIndex = this.currentImageIndex - 1;
    }
  }

  openModal(currentImageIndex: number, files: WiFilePartial[]) {
    this.currentImageIndex = currentImageIndex;
    this.picturesInLightbox = files;
    this.showModal = true;
  }

  closeModal() {
    this.showModal = false;
  }
}
